import { render, staticRenderFns } from "./PayByVirtual.vue?vue&type=template&id=1df315d0&"
import script from "./PayByVirtual.vue?vue&type=script&lang=js&"
export * from "./PayByVirtual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports